import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, message } from 'antd';
import { CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config";

import './Confirm.css';

class Confirm extends Component {

  state = {
    visible: false,
    display: 'none',
  };

  componentWillReceiveProps(thisProps) {
    if (thisProps.visible === true) {
      this.setState({
        visible: true
      })
    }
  }

  handleResend = () => {

    const userPool = new CognitoUserPool(POOL_DATA);

    const userData = {
      Username : this.props.userName,
      Pool : userPool
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) {
        message.error(String(err).split(': ')[1]);
        return;
      }
      message.success('We have resend an email containing verification link');
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });

  };

  handleAlreadyVerified = () => {
    this.handleCancel();
    this.props.history.push('/login');
  };

  render() {
    return (
      <Modal
        visible={this.state.visible}
        className="Confirm"
        onCancel={this.handleCancel}
      >
        <h2>Confirm Your Email Address</h2>
        <p>We have send an email containing verification link to <span>{this.props.email}</span>, just check and click it.</p>
        <div className="buttons">
          <button onClick={this.handleResend} className="Resend">Did not receive? Resend</button>
          <button onClick={this.handleAlreadyVerified} className="Already">I have already verified</button>
        </div>
        <ul>
          <li>You'll be able to login after verify your email</li>
          <li>If you think you have filled out the wrong email, just <span onClick={this.handleCancel}>close</span> and re-registration</li>
        </ul>
      </Modal>
    );
  }
}

export default withRouter(Confirm);



// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Confirm.js